import React from 'react';

import { SimpleIcon, useSvgId } from './icon-utils';

export function TemplateLinkedIcon() {
  const clipPathId = useSvgId('template-linked-clip');

  return (
    <SimpleIcon fill="none" height="110" viewBoxDimensions="0 0 110 110" width="110">
      <circle cx="55" cy="55" fill="#F5F6FB" r="55" />
      <g clipPath={`url(#${clipPathId})`}>
        <path
          d="M38.5706 60.846L31.4479 65.8994C30.4479 66.6087 30.0293 67.8887 30.4159 69.0514L33.0933 77.0914C33.4693 78.23 34.5333 78.998 35.7333 78.998H44.6293C45.8293 78.998 46.8933 78.23 47.2719 77.0914L49.9493 69.0514C50.3359 67.8887 49.9173 66.6087 48.9173 65.8994L41.7946 60.846C40.8266 60.1607 39.5359 60.1607 38.5706 60.846Z"
          stroke="#475464"
          strokeWidth="2"
        />
        <path
          d="M34.1813 32.332H46.1813C47.6533 32.332 48.848 33.5267 48.848 34.9987V46.9987C48.848 48.4707 47.6533 49.6654 46.1813 49.6654H34.1813C32.7093 49.6654 31.5146 48.4707 31.5146 46.9987V34.9987C31.5146 33.5267 32.7093 32.332 34.1813 32.332Z"
          stroke="#475464"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M70.0213 60.332C64.8667 60.332 60.688 64.5107 60.688 69.6654C60.688 74.82 64.8667 78.9987 70.0213 78.9987C75.176 78.9987 79.3547 74.82 79.3547 69.6654C79.3547 64.5107 75.176 60.332 70.0213 60.332Z"
          stroke="#475464"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
        <path
          d="M67.2799 33.852L60.4879 44.7214C59.1412 46.8734 60.6906 49.6654 63.2266 49.6654H76.8132C79.3519 49.6654 80.8986 46.8734 79.5519 44.7214L72.7626 33.852C71.4959 31.8254 68.5466 31.8254 67.2799 33.852Z"
          stroke="#475464"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
        />
      </g>
      <defs>
        <clipPath id={clipPathId}>
          <rect fill="white" height="64" transform="translate(23 23)" width="64" />
        </clipPath>
      </defs>
    </SimpleIcon>
  );
}
